import styled from 'styled-components';

export const StepsWidgetSC = styled.div`
  background: #fff;
  border-radius: 15px;
  box-shadow: 0 0 16px 0 rgba(51, 61, 108, 0.1);
  margin-bottom: 16px;

  .steps-header {
    display: flex;
    align-items: center;
    height: 54px;
    border-bottom: 2px solid #f5f5f7;
    padding-left: 16px;
    padding-right: 6px;

    svg {
      width: 24px;
      height: 24px;
      margin-right: 8px;
    }

    h6 {
      font-size: 16px;
      font-weight: 600;
      opacity: 0.6;
      margin-bottom: 0;
    }
  }
  .steps-body {
    display: flex;
    align-items: center;
    padding: 8px 0;
    &__progress {
      width: 45%;
      display: flex;
      justify-content: center;
      height: 84px;
      position: relative;
      .count {
        position: absolute;
        transform: translate(-50%, -50%);
        left: 50%;
        top: 50%;
        font-size: 14px;
        font-weight: 800;
        &.empty {
          font-size: 11px;
          font-weight: 600;
        }
      }
      svg {
        margin-top: -15px;
      }
      span {
        display: none;
      }
    }
    &__data {
      width: 55%;
      display: flex;
      flex-direction: column;
      b {
        color: #293157;
        font-weight: 800;
        font-size: 14px;
      }
      span {
        min-width: 70px;
        display: inline-block;
        font-size: 13px;
        font-weight: 600;
        opacity: 0.5;
        margin-bottom: 0;
      }
    }
  }
  .steps-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-top: 2px solid #f5f5f7;
    height: 54px;
    padding: 0 16px 0 24px;
  }
`;
